/* tslint:disable */
/* eslint-disable */
/**
 * NORA Api
 *  ## Headers  ### X-App-Version  Remember to include the `X-App-Version` header in every request. This will verify that the app version works with this API version. The API will return a `X-Minimum-App-Version` header as well including the minimum app version that is supported by this API. The contents of the header are is a JSON encoded DTO, `VersionHeaderDTO`. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResult } from '../models';
// @ts-ignore
import type { CreatePermission200Response } from '../models';
// @ts-ignore
import type { ListPermissions200Response } from '../models';
/**
 * NexusAccessPermissionApi - axios parameter creator
 */
export const NexusAccessPermissionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new permission
         * @summary Create a permission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPermission: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/nexus/access/permission`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a specific permission based on permission id
         * @summary Delete a permission
         * @param {string} permissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePermission: async (permissionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'permissionId' is not null or undefined
            assertParamExists('deletePermission', 'permissionId', permissionId)
            const localVarPath = `/api/nora/nexus/access/permission/{permissionId}`
                .replace('{permissionId}', encodeURIComponent(String(permissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return a specific permission based on a permission id
         * @summary Get a single permission
         * @param {string} permissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermission: async (permissionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'permissionId' is not null or undefined
            assertParamExists('getPermission', 'permissionId', permissionId)
            const localVarPath = `/api/nora/nexus/access/permission/{permissionId}`
                .replace('{permissionId}', encodeURIComponent(String(permissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all permissions
         * @summary List all permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPermissions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/nexus/access/permission`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a permission
         * @summary Update a permission
         * @param {string} permissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePermission: async (permissionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'permissionId' is not null or undefined
            assertParamExists('updatePermission', 'permissionId', permissionId)
            const localVarPath = `/api/nora/nexus/access/permission/{permissionId}`
                .replace('{permissionId}', encodeURIComponent(String(permissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NexusAccessPermissionApi - functional programming interface
 */
export const NexusAccessPermissionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NexusAccessPermissionApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new permission
         * @summary Create a permission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPermission(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatePermission200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPermission(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusAccessPermissionApi.createPermission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a specific permission based on permission id
         * @summary Delete a permission
         * @param {string} permissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePermission(permissionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePermission(permissionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusAccessPermissionApi.deletePermission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return a specific permission based on a permission id
         * @summary Get a single permission
         * @param {string} permissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPermission(permissionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatePermission200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPermission(permissionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusAccessPermissionApi.getPermission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all permissions
         * @summary List all permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPermissions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPermissions200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPermissions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusAccessPermissionApi.listPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a permission
         * @summary Update a permission
         * @param {string} permissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePermission(permissionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePermission(permissionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusAccessPermissionApi.updatePermission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NexusAccessPermissionApi - factory interface
 */
export const NexusAccessPermissionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NexusAccessPermissionApiFp(configuration)
    return {
        /**
         * Create a new permission
         * @summary Create a permission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPermission(options?: RawAxiosRequestConfig): AxiosPromise<CreatePermission200Response> {
            return localVarFp.createPermission(options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a specific permission based on permission id
         * @summary Delete a permission
         * @param {NexusAccessPermissionApiDeletePermissionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePermission(requestParameters: NexusAccessPermissionApiDeletePermissionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.deletePermission(requestParameters.permissionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return a specific permission based on a permission id
         * @summary Get a single permission
         * @param {NexusAccessPermissionApiGetPermissionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermission(requestParameters: NexusAccessPermissionApiGetPermissionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreatePermission200Response> {
            return localVarFp.getPermission(requestParameters.permissionId, options).then((request) => request(axios, basePath));
        },
        /**
         * List all permissions
         * @summary List all permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPermissions(options?: RawAxiosRequestConfig): AxiosPromise<ListPermissions200Response> {
            return localVarFp.listPermissions(options).then((request) => request(axios, basePath));
        },
        /**
         * Update a permission
         * @summary Update a permission
         * @param {NexusAccessPermissionApiUpdatePermissionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePermission(requestParameters: NexusAccessPermissionApiUpdatePermissionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.updatePermission(requestParameters.permissionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deletePermission operation in NexusAccessPermissionApi.
 */
export interface NexusAccessPermissionApiDeletePermissionRequest {
    readonly permissionId: string
}

/**
 * Request parameters for getPermission operation in NexusAccessPermissionApi.
 */
export interface NexusAccessPermissionApiGetPermissionRequest {
    readonly permissionId: string
}

/**
 * Request parameters for updatePermission operation in NexusAccessPermissionApi.
 */
export interface NexusAccessPermissionApiUpdatePermissionRequest {
    readonly permissionId: string
}

/**
 * NexusAccessPermissionApi - object-oriented interface
 */
export class NexusAccessPermissionApi extends BaseAPI {
    /**
     * Create a new permission
     * @summary Create a permission
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createPermission(options?: RawAxiosRequestConfig) {
        return NexusAccessPermissionApiFp(this.configuration).createPermission(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a specific permission based on permission id
     * @summary Delete a permission
     * @param {NexusAccessPermissionApiDeletePermissionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePermission(requestParameters: NexusAccessPermissionApiDeletePermissionRequest, options?: RawAxiosRequestConfig) {
        return NexusAccessPermissionApiFp(this.configuration).deletePermission(requestParameters.permissionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return a specific permission based on a permission id
     * @summary Get a single permission
     * @param {NexusAccessPermissionApiGetPermissionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPermission(requestParameters: NexusAccessPermissionApiGetPermissionRequest, options?: RawAxiosRequestConfig) {
        return NexusAccessPermissionApiFp(this.configuration).getPermission(requestParameters.permissionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all permissions
     * @summary List all permissions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listPermissions(options?: RawAxiosRequestConfig) {
        return NexusAccessPermissionApiFp(this.configuration).listPermissions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a permission
     * @summary Update a permission
     * @param {NexusAccessPermissionApiUpdatePermissionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePermission(requestParameters: NexusAccessPermissionApiUpdatePermissionRequest, options?: RawAxiosRequestConfig) {
        return NexusAccessPermissionApiFp(this.configuration).updatePermission(requestParameters.permissionId, options).then((request) => request(this.axios, this.basePath));
    }
}

